import { inject, observer } from "mobx-react";
import React, { memo } from "react";
import { useNavigate } from "react-router-dom";
import HeadPhone from "../components/image/HeadPhone";
import LightLogo from "../components/image/LightLogo";
import MainLayout from "../layouts/MainLayout";
import { ACL_ACTION_TYPE, MODULE_CODE } from "../utils/constants";

const MenuPage = ({ authenticationStore, aclStore, moduleStore }) => {
    const navigate = useNavigate();
    const { currentUser, isAccountAdmin, isSuperAdmin } = authenticationStore;
    const isAccessControl = (moduleCode, accessControlType) => {
        if (isSuperAdmin) return true;
        if (!moduleStore.checkAccessModule(moduleCode)) return false;
        if (accessControlType)
            return (
                isAccountAdmin ||
                !!aclStore?.aclActionsByUser.find(
                    (item) => item.code === accessControlType
                )?.status
            );
        return true;
    };
    return (
        <MainLayout initialValue={4}>
            <div className="flex-col px-5">
                <div className="flex items-center justify-between ">
                    <LightLogo />
                    <span className="flex items-center gap-x-3">
                        <span>
                            <HeadPhone />
                        </span>
                        <span className="text-sm font-semibold">Hỗ trợ</span>
                    </span>
                </div>
                <div className="text-primary text-[30px] font-normal flex flex-col mt-[150px] gap-y-4">
                    <span
                        onClick={() => {
                            navigate("/my-profile");
                        }}
                    >
                        ◦ Cá nhân
                    </span>
                    {isAccessControl(
                        MODULE_CODE.thong_bao_chung,
                        ACL_ACTION_TYPE.menu__NEWS
                    ) && (
                            <span
                                onClick={() => {
                                    navigate("/utility/general-notifications");
                                }}
                            >
                                ◦ Thông báo chung
                            </span>
                        )}
                    {/* {isAccessControl(
                        MODULE_CODE.lien_thong_van_ban,
                        ACL_ACTION_TYPE.menu__LIEN_THONG_VB
                    ) && <span>◦ Liên thông văn bản</span>} */}

                    {isAccessControl(
                        MODULE_CODE.nhiem_vu,
                        ACL_ACTION_TYPE.menu__MISSION
                    ) && (
                            <span
                                onClick={() => {
                                    navigate("/mission");
                                }}
                            >
                                ◦ Nhiệm vụ
                            </span>
                        )}
                    {/* {isAccessControl(
                        MODULE_CODE.tin_nhan_noi_bo,
                        ACL_ACTION_TYPE.menu__TIN_NHAN_NOI_BO
                    ) && <span>◦ Tin nhắn nội bộ</span>} */}
                    <span>◦ Danh bạ</span>
                </div>
            </div>
        </MainLayout>
    );
};

export default memo(
    inject("authenticationStore", "moduleStore", "aclStore")(observer(MenuPage))
);
